// import Swiper JS
import Swiper, { Navigation, Autoplay } from 'swiper';

const $ = window.jQuery;

const gallerySwiper = {
	init() {
		var $gallery = $(document).find('.edu-gallery-block');

		if (!$gallery.length) return;


		// configure Swiper to use modules
		Swiper.use([Navigation, Autoplay]);

		const swiper = new Swiper($gallery[0], {
			slidesPerView: 1,
			spaceBetween: 0,
			loop: true,
			infinit: false,
			cache: true,
			lazy: true,

			observer: true,
			observeParents: true,
			mousewheel: {
				forceToAxis: true,
			},
			autoplay: {
				delay: 6500,
				disableOnInteraction: false,
			},
			navigation: {
				nextEl: '.swiper-button-next',
				prevEl: '.swiper-button-prev',
			},
		});


	},
};

export default gallerySwiper;
